import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

/**
 * PremiumInlineTeaser — the most subtle Premium hint we ship.
 * Used on /reflection so it never dominates the reflection experience.
 * A small line of text + a Learn more link that routes to /premium.
 */
export function PremiumInlineTeaser({ Icon, textKey, testId }) {
  const { t } = useI18n();
  return (
    <div
      className="mt-6 flex items-start gap-2.5 px-2"
      data-testid={testId}
    >
      {Icon ? (
        <Icon
          size={14}
          className="text-[#F4C95D]/75 mt-0.5 flex-none"
          strokeWidth={1.6}
        />
      ) : null}
      <p className="text-[12px] text-[#94A3B8] leading-relaxed">
        {t(textKey)}{" "}
        <Link
          to="/premium"
          data-testid={testId ? `${testId}-link` : undefined}
          className="text-[#F4C95D]/85 hover:text-[#F4C95D] underline underline-offset-4 decoration-white/15 hover:decoration-[#F4C95D]/50 transition-colors duration-200"
        >
          {t("premium.cta.learnMore")}
        </Link>
      </p>
    </div>
  );
}
